import styled, { css } from 'styled-components'

export const Input = styled.input<{ bordered: boolean; error?: boolean }>`
  width: 100%;
  height: 4.2rem;
  border-radius: 50px;
  border: 1px solid
    ${({ theme, bordered }) => (bordered ? theme.colors.border : 'transparent')};
  font-size: 14px;
  padding: 0 10rem 0 2rem;
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.fonts.brand};
  background: ${({ theme }) => theme.colors.background};
  box-sizing: border-box;
  font-weight: 400;

  ${({ error }) => {
    return (
      error &&
      css`
        border-color: ${({ theme }) => theme.colors.danger};
      `
    )
  }}

  &::placeholder {
    opacity: 0.8;
    font-family: ${({ theme }) => theme.fonts.brand};
  }

  &:disabled() {
    background: ${({ theme }) => theme.colors.background};
  }
`

export const InputWrapper = styled.div`
  width: 100%;
  position: relative;
`

export const ButtonWrapper = styled.div`
  width: 8rem;
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
`
